import type { ReactNode } from "react";
import type { ItemVersion } from "scantling-common";
import { DateDisplay, PhaseChip } from "./components.js";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/components/ui/hover-card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";

interface ItemHoverCardProps {
  item: ItemVersion;
  children: ReactNode;
}

export function ItemHoverCard({ item, children }: ItemHoverCardProps) {
  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent className="w-72" align="start">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm font-medium">{item.slug}</span>
            <PhaseChip phase={item.phase} />
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span>v{item.version}</span>
            <span>·</span>
            <DateDisplay value={item.createdAt} />
          </div>
          {item.slots.length > 0 && (
            <>
              <Separator />
              <div className="flex flex-col gap-1.5">
                <span className="text-xs font-medium text-muted-foreground">
                  Slots ({item.slots.length})
                </span>
                <ul className="flex flex-col gap-1">
                  {item.slots.map(slot => (
                    <li
                      key={slot.name}
                      className="flex items-center justify-between text-xs"
                    >
                      <span className="truncate font-mono">{slot.name}</span>
                      <Badge variant="secondary" className="text-xs">
                        {slot.kind}
                      </Badge>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
